import { render, staticRenderFns } from "./FormAdd.vue?vue&type=template&id=3a337113&"
import script from "./FormAdd.vue?vue&type=script&lang=ts&"
export * from "./FormAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a337113')) {
      api.createRecord('3a337113', component.options)
    } else {
      api.reload('3a337113', component.options)
    }
    module.hot.accept("./FormAdd.vue?vue&type=template&id=3a337113&", function () {
      api.rerender('3a337113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/FormAdd.vue"
export default component.exports